import { atom } from 'recoil'
import { HeadingFilter } from '../heading/heading-atom'

export const modalFilterReportsAtom = atom<HeadingFilter>({
  key: 'modalFilterReportsAtom',
  default: {
    patient: null,
    cancerType: null,
    treatment: null,
    status: null,
    genomicVariation: null,
  },
})
